export const ru = {
    title: 'В данный момент у вас нет доступа к сервису',
    description: 'Обратитесь к координатору вашей компании',
};
